// NOTE: The purpose of this function is to check whether the input string starts from http:// or https:// and return a boolean value based on it.

export const hasHttpPrefix = (inputUrl: string): boolean => {
  let pattern = new RegExp('^(https?:\\/\\/)')
  return !!pattern.test(inputUrl)
}
